/**
 * Validate password
 *
 * @param {String} password
 *
 * @return {boolean}
 */
export function isPasswordStrongValidation(password) {
    if (!password) {
        return null;
    }

    return /[A-Z]/.test(password) && /[_+=$@!%*#?&/]/.test(password) ? null : 'validation.error.password_strong';
}



// WEBPACK FOOTER //
// ./src/utils/isPasswordStrongValidation.js